export default {
  HOUSE: 'HOUSE',
  FRIENDS: 'FRIENDS'
}
